import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'cmsConfig',
      'menus',
      'pinedMenus',
      'portalMenus',
      'businessName',
      'userInfo',
      'showHeatmap',
      'menuPath'
    ]),
    ...mapState('popHome',['winInfo'])
  },
  methods: {
    ...mapActions([
      'getCMSConfig',
      'getMenus',
      'getMenusV2',
      'getPortalMenu',
      'logout',
      'setCurrentMenuPath'
    ])
  }
}
